import React, { useEffect } from 'react';
import './Features.css'; // Ensure you're importing the correct CSS file
import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS styles

const Features = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <section id="features">
      <h2 className="section-title">Primary Features</h2>

      {/* Auction View */}
      <div className="feature-item" data-aos="fade-up">
        <div className="feature-image auction-view"></div>
        <div className="feature-content">
          <h3>Auction View</h3>
          <p>
            The Auction View serves as the central hub for managing your entire player auction event. This 
            comprehensive dashboard provides administrators with powerful tools to orchestrate seamless auctions.
          </p>
          <ul>
            <li>Add teams and players to your auction with intuitive interfaces</li>
            <li>Manage base bids and customize auction settings for different sports</li>
            <li>Track everything in real-time with our dynamic monitoring system</li>
            <li>Control auction timing, pauses, and special bidding rounds</li>
            <li>Access detailed analytics on bidding patterns and team strategies</li>
          </ul>
          <p>
            Whether you're organizing a small local tournament or a large professional league draft, the Auction 
            View provides all the tools needed to ensure a smooth and transparent process.
          </p>
        </div>
      </div>

      {/* Team View */}
      <div className="feature-item" data-aos="fade-up">
        <div className="feature-image team-view"></div>
        <div className="feature-content">
          <h3>Team View</h3>
          <p>
            The Team View offers comprehensive insights into each participating team's status and performance 
            throughout the auction process. This feature is essential for both team managers and spectators 
            who want to follow the evolving team compositions.
          </p>
          <ul>
            <li>Track each team's current balance and budget utilization</li>
            <li>View detailed list of registered players with their positions</li>
            <li>Monitor assigned player values and total team spending in real-time</li>
            <li>Access team-specific bidding history and strategy patterns</li>
            <li>Compare team rosters and identify strengths and weaknesses</li>
          </ul>
          <p>
            Team managers can use this view to make informed decisions about future bids, while spectators 
            can follow their favorite teams' progress and analyze team-building strategies.
          </p>
        </div>
      </div>

      {/* Player View */}
      <div className="feature-item" data-aos="fade-up">
        <div className="feature-image player-view"></div>
        <div className="feature-content">
          <h3>Player View</h3>
          <p>
            The Player View provides detailed information about all registered athletes, making it easy to 
            evaluate talent and track player movement throughout the auction. This comprehensive database 
            serves as a valuable resource for teams and fans alike.
          </p>
          <ul>
            <li>Browse all registered players with detailed statistics and profiles</li>
            <li>Check base values and current bidding status for each player</li>
            <li>Filter sold, unsold, and passed players with advanced search options</li>
            <li>View player performance history and position-specific metrics</li>
            <li>Access comparative analysis tools for similar players</li>
          </ul>
          <p>
            This feature helps teams make data-driven decisions by providing comprehensive player information 
            and market analysis. Spectators can follow their favorite players and understand their value 
            in the current auction environment.
          </p>
        </div>
      </div>

      {/* Final Bid */}
      <div className="feature-item" data-aos="fade-up">
        <div className="feature-image final-bid"></div>
        <div className="feature-content">
          <h3>Final Bid</h3>
          <p>
            The Final Bid feature provides complete transparency into auction results, ensuring all participants 
            have access to accurate and detailed transaction information. This comprehensive record serves as 
            the official documentation of the auction outcomes.
          </p>
          <ul>
            <li>View final bid amounts for all players with timestamp information</li>
            <li>Access complete transaction history with team and player details</li>
            <li>Ensure transparency and fair bidding process with auditable records</li>
            <li>Generate detailed reports for league administration and financial tracking</li>
            <li>Export data in multiple formats for further analysis and record keeping</li>
          </ul>
          <p>
            This feature is crucial for post-auction analysis, helping teams understand market trends and 
            player valuations. League administrators can use this data to ensure compliance with budget 
            restrictions and maintain competitive balance.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;